import { http } from '@/api/http';
import { PaginatedApiResponseBody, PaginationSearchParams } from '@/api/types';
import { AirportType } from './airports.types';
import { getAirportsApiUrl } from './airports.paths';

const getAirportsList = async (params: PaginationSearchParams) => {
  const res = await http.get<PaginatedApiResponseBody<AirportType>>(getAirportsApiUrl.list(), {
    params,
  });
  return res.data.data;
};

const getAirportsByIds = async (ids: string, idsFilterType: 'ids' | 'maoIds' = 'ids') => {
  const res = await http.get<PaginatedApiResponseBody<AirportType>>(getAirportsApiUrl.list(), {
    params: { [idsFilterType]: ids },
  });
  return res.data.data;
};

export const airportApiFetcher = {
  getAirportsList,
  getAirportsByIds,
};
